import { Flex } from '@radix-ui/themes';
import { ReactNode } from 'react';

export const Layout = (props: { nav?: ReactNode; children: ReactNode }) => {
  return (
    <Flex direction="column" gap="4" p="4">
      {props.nav}
      {props.children}
    </Flex>
  );
};
